import { useNotifier } from '@provider/notifier';
import { PM2InfoIcon } from '@ui/kit/icons';
import { useOpgavekompleksetComponent } from '../../state/context.data.js';
import { sep, flowTypeLabel, dialog, datalist } from './_flow-type-context.style.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

function FlowTypeContext() {
  const notifier = useNotifier();
  const component = useOpgavekompleksetComponent();
  const flowTypeLabel$1 = (() => {
    switch (component.data.settings.flowType) {
      case "conditional":
        return "Forgrenet";
      case "no-feedback":
        return "Åben";
      case "test-in-order":
        return "Test dig selv";
      case "test-random":
        return /*#__PURE__*/jsxs(Fragment, {
          children: ["Test ", /*#__PURE__*/jsx("span", {
            className: sep,
            children: "|"
          }), " Blandet"]
        });
      case "training-in-order":
        return "Træning";
      case "training-random":
        return /*#__PURE__*/jsxs(Fragment, {
          children: ["Tr\xE6ning ", /*#__PURE__*/jsx("span", {
            className: sep,
            children: "|"
          }), " Blandet"]
        });
    }
  })();
  const onClick = () => {
    notifier.dialog({
      className: dialog,
      heading: "Forskellige typer af opgavesæt",
      body: /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsxs("dl", {
          className: datalist,
          children: [/*#__PURE__*/jsx("dt", {
            children: "Tr\xE6ning"
          }), /*#__PURE__*/jsx("dd", {
            children: /*#__PURE__*/jsxs("ul", {
              children: [/*#__PURE__*/jsx("li", {
                children: "Du f\xE5r l\xF8bende tjekket dine opgavesvar, n\xE5r du trykker \u2018tjek\u2019."
              }), /*#__PURE__*/jsx("li", {
                children: "Du kan g\xE5 frem og tilbage i opgaves\xE6ttet."
              })]
            })
          }), /*#__PURE__*/jsx("dt", {
            children: "Test"
          }), /*#__PURE__*/jsx("dd", {
            children: /*#__PURE__*/jsxs("ul", {
              children: [/*#__PURE__*/jsx("li", {
                children: "Du f\xE5r f\xF8rst rettet dine svar til slut i opgaves\xE6ttet."
              }), /*#__PURE__*/jsx("li", {
                children: "Du kan g\xE5 frem og tilbage i opgaves\xE6ttet."
              })]
            })
          }), /*#__PURE__*/jsx("dt", {
            children: "\xC5ben"
          }), /*#__PURE__*/jsx("dd", {
            children: /*#__PURE__*/jsx("ul", {
              children: /*#__PURE__*/jsx("li", {
                children: "I denne type opgaves\xE6t er der ikke noget rigtigt eller forkert svar. Slutsiden vil derfor kun vise dine svar uden rettelser."
              })
            })
          }), /*#__PURE__*/jsx("dt", {
            children: "Forgrenet"
          }), /*#__PURE__*/jsx("dd", {
            children: /*#__PURE__*/jsx("ul", {
              children: /*#__PURE__*/jsx("li", {
                children: "Her er n\xE6ste opgave i r\xE6kken afh\xE6ngigt af dit svar p\xE5 den forrige opgave."
              })
            })
          }), /*#__PURE__*/jsx("dt", {
            children: "Blandet"
          }), /*#__PURE__*/jsx("dd", {
            children: /*#__PURE__*/jsx("ul", {
              children: /*#__PURE__*/jsx("li", {
                children: "Du ser ikke de samme opgaver som andre. Opgaverne vises enten i forskellig r\xE6kkef\xF8lge, eller der er forskellige opgaver i s\xE6ttet indenfor samme emne."
              })
            })
          })]
        })
      }),
      actions: [{
        type: "primary",
        label: "OK",
        intent: "ok"
      }]
    });
  };
  return /*#__PURE__*/jsxs("button", {
    className: flowTypeLabel,
    onClick: onClick,
    children: [flowTypeLabel$1, /*#__PURE__*/jsx(PM2InfoIcon, {
      height: 15
    })]
  });
}

export { FlowTypeContext };
//# sourceMappingURL=_flow-type-context.js.map
